import { createUseStyles } from 'react-jss'
import { colors } from '../../variables.style'

const GRID_WIDTH = 1024
const COLUMN_WIDTH = 130
const GRABBER_COLUMN_WIDTH = 25
const INTERNAL_SPACING = 5
const BORDER = `1px solid ${colors.borderGray}`

export const style = {
  container: {
    width: GRID_WIDTH,
    borderBottom: BORDER
  },
  gridLabel: {
    paddingLeft: INTERNAL_SPACING,
    display: 'flex',
    alignItems: 'flex-end'
  },
  editLabelsButton: {
    color: colors.brandPrimary,
    fontSize: 11,
    padding: 0,
    height: 'auto',
    margin: '0 0 5px 10px'
  },
  columnLabelCell: {
    width: COLUMN_WIDTH,
    padding: INTERNAL_SPACING,
    textAlign: 'center',
    alignSelf: 'flex-end',
    fontSize: 12
  },
  gridRow: {
    display: 'flex',
    border: BORDER,
    borderBottom: 'none',
    '&:nth-child(odd)': {
      backgroundColor: colors.tableRowStripedBackground
    },
    '&:nth-child(even)': {
      backgroundColor: colors.backgroundGray
    }
  },
  grabberCell: {
    width: GRABBER_COLUMN_WIDTH,
    display: 'flex',
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'center'
  },
  labelCell: {
    padding: INTERNAL_SPACING,
    fontSize: 14
  },
  checkCell: {
    width: COLUMN_WIDTH,
    padding: INTERNAL_SPACING,
    textAlign: 'center'
  },
  checkWrapper: {
    position: 'relative',
    display: 'inline'
  },
  disabledCheckCatcher: {
    position: 'absolute',
    inset: 0
  },
  warning: {
    backgroundColor: colors.warning,
    color: 'white'
  },
  error: {
    backgroundColor: colors.error,
    color: 'white'
  },
  modalBody: {
    padding: 0,
    overflowX: 'hidden'
  },
  labelEditRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px',
    '&:nth-child(odd)': {
      backgroundColor: colors.tableRowStripedBackground
    }
  },
  labelEditRowValue: {
    width: '50%',
    padding: '0 10px 0 20px',
    overflowWrap: 'break-word'
  },
  labelEditRowLabel: {
    width: '50%'
  },
  tooltipContent: {
    composes: 'tooltip-content',
    width: 180
  }
}

export function calculateLabelColumnWidth (columnCount) {
  return GRID_WIDTH - GRABBER_COLUMN_WIDTH - (COLUMN_WIDTH * columnCount)
}

export const useStyles = createUseStyles(style)
